<script>
import UtilsMixin from "@/mixins/utils";
import LocaleMixin from "@/mixins/locale";
export default {
  name: 'printOrder',
  components: {},
  props: {
    data: Object,
    me: Object,
  },
  data() {
    return {
      timePrint: this.timeCreate()
    }
  },
  mixins: [UtilsMixin, LocaleMixin],
  methods: {
    timeCreate() {
      let date = new Date(Date.now());
      return {
        year: date.getFullYear(),
        month: date.getMonth() >= 10 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`,
        day: date.getDate() >= 10 ?date.getDate() : `0${date.getDate()}`,
        hour: date.getHours(),
        min: date.getMinutes(),
        sec: date.getSeconds(),
      }
    }
  }
};
</script>

<template>
  <div class="page order-page">
    <div class="mb-2" v-if="distributor && distributor.id">
      <p v-if="distributor.distributor_name" class="text-uppercase mb-1 font-size-18"><b>{{ distributor.distributor_name }}</b></p>
      <p v-if="distributor.tax_code" class="mb-1 font-size-16">{{ $t('print.abn_x',{value: distributor.tax_code}) }}</p>
      <p v-if="distributor.distributor_address" class="mb-1 font-size-16">{{ $t('print.address_x',{value: distributor.distributor_address}) }}</p>
      <p v-if="distributor.distributor_phone" class="mb-0 font-size-16">{{ $t('print.tel_x',{value: distributor.distributor_phone}) }}</p>
      <p v-if="distributor.distributor_id === 'SUNLIFE'" class="mb-0 font-size-16">{{ 'ABN : 136 525 281 88' }}</p>
    </div>
    <div class="text-center" style="font-size: 30px">{{$t('print.order').toUpperCase()}}</div>
    <div class="d-flex justify-content-between">
      <div class="information-invoice">
        <p v-if="data.po_date" class="item_information mb-1 font-size-14">
          <span class="label">{{$t('print.date')}}</span>
          <span class="value">{{formatDate(data.po_date,'hour')}}</span>
        </p>
        <p v-if="data.po_id" class="item_information mb-1 font-size-14">
          <span class="label">{{$t('print.invoice')}}</span>
          <span class="value">{{data.po_id}}</span>
        </p>
        <p v-if="data.customer_id" class="item_information mb-1 font-size-14">
          <span class="label">{{$t('print.customer_id')}}</span>
          <span class="value">{{data.customer_id}}</span>
        </p>
        <p v-if="data.customer_id" class="item_information mb-0 font-size-14">
          <span class="label">{{$t('print.due_date')}}</span>
          <span class="value">{{formatDate(data.require_time,'hour')}}</span>
        </p>
      </div>
      <div>
        <img :src="`https://chart.googleapis.com/chart?chs=100x100&cht=qr&chld=L|0&chl=${data.id}`" alt="QR">
      </div>
    </div>
    <hr class="mb-2 mt-2">
    <div class="print-content mb-4">
      <p class="mb-1 font-weight-bold font-size-14">{{$t('print.bill_to')}} {{data.customer_name}}</p>
      <template v-if="data.customer_store">
        <p class="mb-1 font-size-14">{{$t('print.tel_x',{value: data.customer_store.store_contact_phone})}}</p>
        <p class="mb-1 font-size-14">{{$t('print.address_x',{value:data.customer_store.store_address})}}</p>
      </template>
    </div>
    <table class="table table-striped">
      <tr>
        <th class="font-size-14">{{$t('print.product')}}</th>
        <th class="font-size-14">{{$t('print.unit')}}</th>
        <th class="font-size-14 text-right">{{$t('print.quantity')}}</th>
        <th class="font-size-14 text-right">
          {{$t('print.price')}}
          <span v-if="currencyType === 'VND'" class="font-weight-light font-italic">({{$t('print.include_vat')}})</span>
        </th>
        <th class="font-size-14 text-right">{{$t('print.discount')}}</th>
        <th class="font-size-14 text-right">{{$t('print.gst')}}</th>
        <th class="font-size-14 text-right">{{$t('print.total')}}</th>
      </tr>
      <tr v-for="(item, key) of data.details" :key="key">
        <td>
          <div class="font-size-14 mb-2">{{item.ids_sku}}</div>
          <div class="font-size-14">{{item.item_name}}</div>
        </td>
        <td class="font-size-14">{{item.unit_name}}</td>
        <td class="font-size-14 text-right">{{formatPrice(item.delivery_qty)}}</td>
        <td class="font-size-14 text-right">{{ item.discount_amount !== 0 ? formatPrice(item.price_basis,true) : formatPrice(item.price,true) }}</td>
        <td class="font-size-14 text-right">{{ formatPrice(item.discount_amount,true) }}</td>
        <td class="font-size-14 text-right">{{ formatPrice(item.amount_vat + item.amount_vat_reverse,true) }}</td>
        <td class="font-size-14 text-right">{{ formatPrice(item.amount + (item.amount_vat || 0),true) }}</td>
      </tr>
    </table>
    <div class="bottom_page d-flex">
      <div class="payment_info mr-3">
        <p class="title_infor_payment font-size-18 mb-1 font-weight-bold">{{$t('print.information_payment').toUpperCase()}}</p>
        <div v-if="distributor.list_payment&&distributor.list_payment.length" class="payment_info_content">
          <div class="sub_title ml-2">{{$t('print.cheque_payable_to') +' '+ distributor.distributor_name}}</div>
          <div class="list ml-2">
            <div v-for="(item,index) in distributor.list_payment" :key="item.id" class="item">
              <hr v-if="index!==0" class="mb-1 mt-1">
              <div class="d-flex align-items-center justify-content-between">
                <p v-if="item.payment_type" class="font-size-14 mb-1">{{$t('print.type')}}: {{$t('print.'+item.payment_type)}}</p>
                <p v-if="item.bsb && item.payment_type === 'BANK'" class="font-size-14 mb-1">{{$t('print.bsb')}}: {{item.bsb}}</p>
              </div>
              <div class="d-flex align-items-center justify-content-between">
                <p v-if="item.payment_name" class="font-size-14 mb-1">{{$t('print.payment_name')}}: {{item.payment_name}}</p>
                <p v-if="item.payment_id" class="font-size-14 mb-1">{{$t('print.payment_id')}}: {{item.payment_id}}</p>
              </div>
            </div>
          </div>
<!--          <div class="footer_payment_info font-size-16 mt-2">{{$t('print.payment_term').toUpperCase()}}:</div>-->
        </div>
      </div>
      <div class="total">
        <div class="item__total d-flex justify-content-between mb-2">
          <div class="font-weight-bold">{{$t('print.sub_total')}}</div>
          <div>{{formatPrice(data.amount,true)}}</div>
        </div>
        <div class="xitem__total d-flex justify-content-between mb-2">
          <div class="font-weight-bold">{{$t('print.discount_amount')}}</div>
          <div>{{formatPrice(data.bill_discount_amount,true)}}</div>
        </div>
        <div class="item__total d-flex justify-content-between mb-2">
          <div class="font-weight-bold">{{$t('print.vat')}}</div>
          <div>{{formatPrice((data.amount_vat+data.amount_vat_reverse),true)}}</div>
        </div>
        <hr class="mb-1 mt-1">
        <div class="item__total d-flex justify-content-between mb-2">
          <div class="font-weight-bold">{{$t('print.final_amount')}}</div>
          <div>{{formatPrice(data.final_amount,true)}}</div>
        </div>
        <div class="item__total d-flex justify-content-between mb-2">
          <div class="font-weight-bold">{{$t('print.paid')}}</div>
          <div>{{formatPrice(data.customer_paid_amount,true)}}</div>
        </div>
        <div class="item__total d-flex justify-content-between mb-2">
          <div class="font-weight-bold">{{$t('print.return_amount')}}</div>
          <div>{{formatPrice(data.return_amount,true)}}</div>
        </div>
        <hr class="mb-1 mt-1">
        <div class="item__total d-flex justify-content-between">
          <div class="font-weight-bold">{{$t('print.debt')}}</div>
          <div>{{formatPrice(data.customer_debt_amount,true)}}</div>
        </div>
        <div class="item__total d-flex justify-content-between">
          <div class="font-weight-bold">{{$t('print.debt_other')}}</div>
          <div>{{formatPrice(data.other_debt_amount,true)}}</div>
        </div>
        <hr class="mb-1 mt-1">
        <div class="item__total d-flex justify-content-between">
          <div class="font-weight-bold">{{$t('print.total_debt')}}</div>
          <div class="font-weight-bold">{{formatPrice((data.customer_debt_amount||0)+(data.other_debt_amount||0),true)}}</div>
        </div>
      </div>
    </div>
    <div class="print-footer d-flex justify-content-around font-size-16 pt-5">
      <div>
        <p class="invisible mb-0">-</p>
        <p class="font-weight-medium text-center mb-0">{{$t('print.receiver')}}</p>
        <p class="font-italic text-center">({{$t('print.sign_full_name_and_confirmation_if_not_yet_paid')}})</p>
      </div>
      <div>
        <p class="mb-0">{{$t('print.day_month_year', {d: timePrint.day, m: timePrint.month, y: timePrint.year})}}</p>
        <p class="font-weight-medium text-center mb-0">{{$t('print.deliver')}}</p>
        <p class="font-italic text-center mb-0">({{$t('print.sign_full_name')}})</p>
      </div>
    </div>
  </div>
</template>